import type { UserCreate } from "@/models/user"
import type { SuccessData } from "@/utils/api"
import { httpClient } from "@/utils/api"
import type { UseMutationOptions } from "@tanstack/react-query"
import type { AxiosError, AxiosResponse } from "axios"

import type { UserMutationError } from "./use-user-mutation"
import { useUserMutation } from "./use-user-mutation"

interface CreateUserResponse extends SuccessData {
  user_id?: string
}

export type CreateUserError = UserMutationError

const createUserApi = async (
  newUser: UserCreate
): Promise<AxiosResponse<CreateUserResponse>> => {
  return httpClient.post<CreateUserResponse>("/api/v1/users", {
    user: newUser,
  })
}

export const useCreateUser = (
  options: UseMutationOptions<
    AxiosResponse<CreateUserResponse>,
    AxiosError<CreateUserError>,
    UserCreate
  > = {}
) =>
  useUserMutation({
    mutationFn: createUserApi,
    resultKey: "createUser",
    fallbackErrorMessage: "addUser.createUserError",
    options,
  })
